import type { TreeNodeDefinition } from '@trimble/ui-components/solidjs';

import type { FxWorkspaceTreeItem } from './fx-workspace-tree.types';

export type FxReferencesViewMode = 'tree' | 'flat';

function isIntermediateReferenceKind(
  kind: FxWorkspaceTreeItem['kind'] | undefined
): boolean {
  return (
    kind === 'referenceCategory' ||
    kind === 'referenceMission' ||
    kind === 'referenceRuns' ||
    kind === 'referenceFolder'
  );
}

export function flattenFxReferenceNodes(
  nodes: TreeNodeDefinition<FxWorkspaceTreeItem>[]
): TreeNodeDefinition<FxWorkspaceTreeItem>[] {
  const referencesFolder = nodes.find(
    (node) => node.data?.kind === 'references'
  );
  if (referencesFolder === undefined) {
    return nodes;
  }

  return nodes.flatMap((node) => {
    const kind = node.data?.kind;
    if (isIntermediateReferenceKind(kind)) {
      return [];
    }

    if (kind === 'reference') {
      return [{ ...node, parentId: referencesFolder.id }];
    }

    return [node];
  });
}
